<template>
  <logo class="logo" />
</template>
<script>
export default {
  components: {
    Logo: () => import('@/assets/Aqua.svg')
  }
}
</script>

<style>
.logo {
  height: fit-content;
  max-width: 200px;
}
</style>
